import { render, staticRenderFns } from "./CustomSimpleSelect.vue?vue&type=template&id=1a1876af&"
import script from "./CustomSimpleSelect.vue?vue&type=script&lang=js&"
export * from "./CustomSimpleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports